import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../wayfinder'
/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:11
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:11
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:11
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:11
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AboutController::__invoke
* @see app/Http/Controllers/AboutController.php:9
* @route '/about'
*/
export const about = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

about.definition = {
    methods: ["get","head"],
    url: '/about',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AboutController::__invoke
* @see app/Http/Controllers/AboutController.php:9
* @route '/about'
*/
about.url = (options?: RouteQueryOptions) => {
    return about.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AboutController::__invoke
* @see app/Http/Controllers/AboutController.php:9
* @route '/about'
*/
about.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AboutController::__invoke
* @see app/Http/Controllers/AboutController.php:9
* @route '/about'
*/
about.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: about.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\MusicController::__invoke
* @see app/Http/Controllers/MusicController.php:11
* @route '/music'
*/
export const music = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: music.url(options),
    method: 'get',
})

music.definition = {
    methods: ["get","head"],
    url: '/music',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MusicController::__invoke
* @see app/Http/Controllers/MusicController.php:11
* @route '/music'
*/
music.url = (options?: RouteQueryOptions) => {
    return music.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\MusicController::__invoke
* @see app/Http/Controllers/MusicController.php:11
* @route '/music'
*/
music.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: music.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MusicController::__invoke
* @see app/Http/Controllers/MusicController.php:11
* @route '/music'
*/
music.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: music.url(options),
    method: 'head',
})

